
export const common = {
  scriptUrl: "https://tags.tiqcdn.com/utag/tmobile/nextgen/qa/utag.js",
  analytics: {
    enabled: true,
    pages: {
      "/apps/tfb_acctmgmt/account-management/home": {
        pageInfo: {
          pageName: "Manage Lines Home",
          site: "TFB Care AHUB"
        },
        category: {
          primaryCategory: "Manage Accounts",
          subCategory: "",
          pageType: "tfb_manageaccount",
        },
        event: {
          eventInfo: {
            eventAction: "load",
            eventType: "page",
            timestamp: Date(),
          },
        },
      },
      "/apps/tfb_acctmgmt/account-management/lines/changeservice": {
        pageInfo: {
          pageName: "Change Services",
          site: "TFB Care AHUB"
        },
        category: {
          primaryCategory: "Hub",
          subCategory: "Account",
          pageType: "changeservices",
        },
        event: {
          eventInfo: {
            eventAction: "load",
            eventType: "page",
            timestamp: Date(),
          },
        },
      },
      "/apps/tfb_acctmgmt/account-management/lines/changeservice/reviewchangeservice": {
        pageInfo: {
          pageName: "Review Change Services",
          site: "TFB Care AHUB"
        },
        category: {
          primaryCategory: "Hub",
          subCategory: "Account",
          pageType: "reviewchangeservice",
        },
        event: {
          eventInfo: {
            eventAction: "load",
            eventType: "page",
            timestamp: Date(),
          },
        },
      },
      "/apps/tfb_acctmgmt/account-management/affiliations/military-verification": {
        pageInfo: {
          pageName: "Submit Military Information",
          site: "TFB Care AHUB"
        },
        category: {
          primaryCategory: "Manage Account",
          subCategory: "Military Verification",
          pageType: "militaryverification",
        },
        event: {
          eventInfo: {
            eventAction: "load",
            eventType: "page",
            timestamp: Date(),
          },
          selfService: {
            name: "TFB Military Verification",
            stage: "start",
          },
        },
      },
      "/apps/tfb_acctmgmt/account-management/affiliations/military-upload": {
        pageInfo: {
          pageName: "Upload military documentation",
          site: "TFB Care AHUB"
        },
        category: {
          primaryCategory: "Manage Account",
          subCategory: "Military Verification",
          pageType: "militaryverification",
        },
        event: {
          eventInfo: {
            eventAction: "load",
            eventType: "page",
            timestamp: Date(),
          }
        },
      },
      "/apps/tfb_acctmgmt/account-management/change-rateplan": {
        pageInfo: {
          pageName: "Change Rate Plan",
          site: "TFB Care AHUB"
        },
        category: {
          primaryCategory: "Manage Accounts",
          subCategory: "",
          pageType: "tfb_changerateplan"
        },
        event: {
          eventInfo: {
            eventAction: "load",
            eventType: "page",
            timestamp: Date()
          },
          selfService :{
            name: "Change Rate Plan",
            stage: "start"
          }
        }
      },
      "/apps/tfb_acctmgmt/account-management/lines": {
        pageInfo: {
          pageName: "Manage Lines - ",
          site: "TFB Care AHUB"
        },
        category: {
          primaryCategory: "Manage Accounts",
          subCategory: "",
          pageType: "tfb_managelines"
        },
        event: {
          eventInfo: {
            eventAction: "load",
            eventType: "page",
            timestamp: Date()
          },
          selfService :{
            name: "Manage Lines",
            stage: "start"
          }
        }
      },
      "/apps/tfb_acctmgmt/account-management/line-details": {
        pageInfo: {
          pageName: "Manage Line Details - ",
          site: "TFB Care AHUB"
        },
        category: {
          primaryCategory: "Manage Accounts",
          subCategory: "",
          pageType: "tfb_linedetails"
        },
        event: {
          eventInfo: {
            eventAction: "load",
            eventType: "page",
            timestamp: Date()
          },
          selfService :{
            name: "Manage Line Details",
            stage: "start"
          }
        }
      }
    },
    components: {},
  },
  DIALPAD: {
    SPECIAL_DIALPAD_PRODUCTS: ['Enterprise Talk', 'Pro Talk', 'Standard Talk', 'Pro TFB Collaborate', 'Enterprise TFB Collaborate']  
  },
  moviusLink: "https://sml.moviuscorp.net/",
};
